

export default function NotFound({ message, isPadding }) {
    return (
        <div className={`w-full flex justify-center items-center ${isPadding && "py-10"}`}>{message ? message : "Content not found"}</div>
    )
};